export const IsEmptyObject = (obj) => {
    return Object.keys(obj).length === 0;
}